import PropTypes from 'prop-types';

import {
  trans,
  getPagePath,
  useSoyuzExperiment
} from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

import { useStateMachineContext } from '@spotahome/landings-common/src/context/StateMachineContext';

import {
  ACCOUNT_CATEGORY,
  BOOKING_CATEGORY,
  NON_BOOKING_CATEGORY,
  TENANT_CONFIG
} from '../../constants';

import ContactUsHeader from '../ContactUsHeader';

import './ContactCategories.scss';
import CategoryCard from '../CategoryCard';
import Key from '../CategoryCard/Illustrations/Key';
import Eye from '../CategoryCard/Illustrations/Eye';
import Account from '../CategoryCard/Illustrations/Account';

const getCategories = () => Object.keys(TENANT_CONFIG);

const CATEGORIES = [
  {
    id: BOOKING_CATEGORY,
    title: 'contact-us.tenant.booking.title',
    description: 'contact-us.tenant.booking.description',
    renderIcon: () => <Key />
  },
  {
    id: NON_BOOKING_CATEGORY,
    title: 'contact-us.tenant.property.title',
    description: 'contact-us.tenant.property.description',
    renderIcon: () => <Eye />
  },
  {
    id: ACCOUNT_CATEGORY,
    title: 'contact-us.tenant.account.title',
    description: 'contact-us.tenant.account.description',
    renderIcon: () => <Account />
  }
];

const ContactCategories = ({
  isHeaderInvisible = false,
  isSupportSection = false
}) => {
  const { payload, send } = useStateMachineContext();
  const isContactFormV3 =
    useSoyuzExperiment('ContactFormV3').get('behaviour') === 'variant';

  const baseLocoKey = `contact-us.${payload.role}.new`;
  let headerLocoKey = baseLocoKey;

  if (isSupportSection) {
    headerLocoKey = isContactFormV3 ? 'support.center' : 'contact-us.go-back';
  }

  const handleCategoryClicked = categoryId => {
    if (categoryId === BOOKING_CATEGORY && !isContactFormV3) {
      window.location.href = getPagePath('my-bookings');
      return;
    }

    if (categoryId === BOOKING_CATEGORY && isContactFormV3) {
      send('SELECT_BOOKINGS', { categoryId: 'booking' });
      return;
    }

    send('SELECT', { categoryId });
  };

  return (
    <>
      <div className="contact-us-form__fields">
        <ContactUsHeader
          title={trans(headerLocoKey)}
          isInvisible={isHeaderInvisible}
          onBack={
            isSupportSection
              ? () => (window.location.href = getPagePath('support'))
              : false
          }
        />
        {isContactFormV3 && (
          <>
            <h1 className="contact-categories__title">
              {trans('support.cards.contact-support.title')}
            </h1>
            <p className="contact-categories__description">
              {trans('contact-us.categories.description')}
            </p>
          </>
        )}
        {!isContactFormV3 &&
          getCategories().map(category => (
            <Button
              dataTest={`${category}-button`}
              key={category}
              color="primary"
              size="large"
              fullWidth
              onClick={() => handleCategoryClicked(category)}
              className="contact-us-form__button"
            >
              {trans(`${baseLocoKey}.${category}`)}
            </Button>
          ))}

        {isContactFormV3 && (
          <div className="contact-categories__info">
            {CATEGORIES.map(({ id, title, description, renderIcon }) => (
              <CategoryCard
                dataTest={`${id}-button`}
                key={id}
                title={trans(title)}
                description={trans(description)}
                renderIcon={renderIcon}
                onClick={() => handleCategoryClicked(id)}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

ContactCategories.propTypes = {
  isHeaderInvisible: PropTypes.bool,
  isSupportSection: PropTypes.bool
};

export default ContactCategories;
